export const CREATE_LICENSE_USER = "CREATE_LICENSE_USER";
export const CREATE_LICENSE_USER_SUCCESS = "CREATE_LICENSE_USER_SUCCESS";
export const CREATE_LICENSE_USER_ERROR = "CREATE_LICENSE_USER_ERROR";

export const CREATE_SUBSCRIPTION = "CREATE_SUBSCRIPTION";
export const CREATE_SUBSCRIPTION_SUCCESS = "CREATE_SUBSCRIPTION_SUCCESS";
export const CREATE_SUBSCRIPTION_ERROR = "CREATE_SUBSCRIPTION_ERROR";

export const GET_SUBSCRIPTIONS = "GET_SUBSCRIPTIONS";
export const GET_SUBSCRIPTIONS_SUCCESS = "GET_SUBSCRIPTIONS_SUCCESS";
export const GET_SUBSCRIPTIONS_ERROR = "GET_SUBSCRIPTIONS_ERROR";

export const GET_SUBSCRIPTION_BILLINGS = "GET_SUBSCRIPTION_BILLINGS";
export const GET_SUBSCRIPTION_BILLINGS_SUCCESS = "GET_SUBSCRIPTION_BILLINGS_SUCCESS";
export const GET_SUBSCRIPTION_BILLINGS_ERROR = "GET_SUBSCRIPTION_BILLINGS_ERROR";

export const CHECK_SUBSCRIPTION_STATUS = "CHECK_SUBSCRIPTION_STATUS";
export const CHECK_SUBSCRIPTION_STATUS_SUCCESS =
  "CHECK_SUBSCRIPTION_STATUS_SUCCESS";
export const CHECK_SUBSCRIPTION_STATUS_ERROR =
  "CHECK_SUBSCRIPTION_STATUS_ERROR";

export const DELETE_SUBSCRIPTION = "DELETE_SUBSCRIPTION";
export const DELETE_SUBSCRIPTION_SUCCESS = "DELETE_SUBSCRIPTION_SUCCESS";
export const DELETE_SUBSCRIPTION_ERROR = "DELETE_SUBSCRIPTION_ERROR";

export const GET_PRODUCTS = "GET_PRODUCTS";
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
export const GET_PRODUCTS_ERROR = "GET_PRODUCTS_ERROR";

export const MARK_SUBSCRIPTION_PAID = "MARK_SUBSCRIPTION_PAID";
export const MARK_SUBSCRIPTION_PAID_SUCCESS = "MARK_SUBSCRIPTION_PAID_SUCCESS";
export const MARK_SUBSCRIPTION_PAID_ERROR = "MARK_SUBSCRIPTION_PAID_ERROR";

export const FREEZE_UNFREEZE_SUBSCRIPTION = "FREEZE_UNFREEZE_SUBSCRIPTION";
export const FREEZE_UNFREEZE_SUBSCRIPTION_SUCCESS = "FREEZE_UNFREEZE_SUBSCRIPTION_SUCCESS";
export const FREEZE_UNFREEZE_SUBSCRIPTION_ERROR = "FREEZE_UNFREEZE_SUBSCRIPTION_ERROR";
